import FreshwatchListEntitiesSearch from '../../../../customized/fresh-watch/components/Group/SearchEntities/FreshwatchListEntitiesSearch';
import { ToggleComponent } from '../../../../featureToggle';
import ListEntitiesSearch from './ListEntitiesSearch';

export default ToggleComponent(ListEntitiesSearch, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchListEntitiesSearch,
  },
});
